import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRemoveRecipientsFromGroupMutation } from "../../../../../recipientsApiSlice";

const RemoveDialog = ({ onClose, open, groupId, recipientId }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [removeRecipient, { isLoading }] =
		useRemoveRecipientsFromGroupMutation();

	const {
		handleSubmit,
		control,
		formState: { errors },
		setError,
	} = useForm({
		// resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	const submitNewUser = async () => {
		await removeRecipient({ groupId, recipientId })
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("removed_carrier_from_mailing_group"), {
					variant: "success",
				});
				onClose();
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Dialog
			fullWidth
			sx={{ maxWidth: "450px", mx: "auto" }}
			onClose={onClose}
			open={open}
		>
			<Box sx={{ padding: "30px" }}>
				<Box component="form" onSubmit={handleSubmit(submitNewUser)}>
					<Grid container rowSpacing={3} columnSpacing={2}>
						<Grid size={12}>
							<Box sx={{ textAlign: "center" }}>
								<Typography variant="h5" component="span">
									{t("are_you_sure")}
								</Typography>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "end" }}>
								<Button
									type="submit"
									loading={isLoading}
									variant="contained"
									color="error"
								>
									{t("remove")}
								</Button>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "start" }}>
								<Button variant="contained" color="secondary" onClick={onClose}>
									{t("cancel")}
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Dialog>
	);
};

export default RemoveDialog;
